var _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path10, _g4, _path11, _path12, _g5, _path13, _path14, _g6, _path15, _path16, _g7, _path17, _path18, _g8, _path19, _path20, _g9, _path21, _path22, _g10, _path23, _path24, _g11, _path25, _path26, _g12, _path27, _path28, _g13, _path29, _path30, _g14, _path31, _path32, _g15, _path33, _path34, _g16, _path35, _path36, _g17, _path37, _path38, _g18, _path39, _path40, _g19, _path41, _path42, _g20, _path43, _path44, _g21, _path45, _path46, _g22, _path47, _path48, _g23, _path49, _path50, _g24, _path51, _path52, _g25, _path53, _rect2, _path54, _path55, _path56, _g26, _path57, _path58, _g27, _path59, _path60, _g28, _path61, _path62, _g29, _path63, _path64, _g30, _path65, _path66, _g31, _path67, _path68, _g32, _path69, _path70, _g33, _path71, _path72, _g34, _path73, _path74, _g35, _path75, _path76, _g36, _path77, _path78, _g37, _path79, _path80, _g38, _path81, _path82, _g39, _path83, _path84, _g40, _path85, _path86, _g41, _path87, _path88, _g42, _path89, _path90, _g43, _path91, _path92, _g44, _path93, _path94, _g45, _path95, _path96, _g46, _path97, _path98, _g47, _path99, _path100, _g48, _path101, _path102, _g49, _path103, _path104, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulti1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 490,
    viewBox: "0 0 358 490",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_11690)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.28125,
    width: 358,
    height: 489,
    rx: 11.0223,
    fill: "#252525",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.907 54.0214L143.14 52.6397H149.65L149.418 54.0214H146.991L145.907 60.5664H144.251L145.334 54.0214H142.907ZM149.406 60.5664L150.722 52.6397H152.398L151.856 55.9102H155.258L155.8 52.6397H157.472L156.156 60.5664H154.484L155.026 57.292H151.624L151.082 60.5664H149.406ZM157.538 60.5664L158.854 52.6397H164.195L163.963 54.0214H160.298L159.988 55.9102H163.378L163.146 57.292H159.756L159.446 59.1846H163.127L162.895 60.5664H157.538ZM172.053 55.4148H170.381C170.386 55.1929 170.358 54.9968 170.296 54.8265C170.234 54.6536 170.141 54.5065 170.017 54.3852C169.896 54.264 169.748 54.1724 169.572 54.1104C169.397 54.0459 169.199 54.0137 168.98 54.0137C168.557 54.0137 168.168 54.1195 167.815 54.3311C167.461 54.5426 167.163 54.8497 166.921 55.2522C166.678 55.6522 166.511 56.136 166.418 56.7037C166.327 57.2507 166.333 57.7087 166.433 58.0777C166.534 58.4467 166.712 58.7253 166.967 58.9137C167.225 59.0995 167.547 59.1924 167.931 59.1924C168.168 59.1924 168.394 59.1627 168.608 59.1034C168.823 59.0414 169.017 58.9537 169.193 58.8402C169.371 58.7241 169.526 58.5834 169.657 58.4183C169.792 58.2531 169.896 58.0661 169.971 57.8571H171.654C171.549 58.2209 171.384 58.5718 171.159 58.9098C170.937 59.2479 170.662 59.5498 170.335 59.8155C170.007 60.0787 169.634 60.2877 169.216 60.4426C168.798 60.5974 168.34 60.6748 167.842 60.6748C167.122 60.6748 166.504 60.5096 165.988 60.1794C165.475 59.8491 165.104 59.373 164.877 58.7512C164.65 58.1293 164.608 57.3797 164.75 56.5024C164.891 55.6535 165.169 54.9336 165.582 54.3427C165.997 53.7492 166.502 53.2989 167.095 52.9919C167.691 52.6848 168.328 52.5313 169.007 52.5313C169.479 52.5313 169.906 52.5958 170.288 52.7248C170.67 52.8538 170.995 53.0422 171.264 53.2899C171.535 53.535 171.738 53.8356 171.875 54.1917C172.012 54.5478 172.071 54.9555 172.053 55.4148ZM180.334 56.7114C180.19 57.5578 179.91 58.2764 179.494 58.8673C179.081 59.4582 178.577 59.9071 177.981 60.2142C177.387 60.5213 176.747 60.6748 176.061 60.6748C175.341 60.6748 174.721 60.5109 174.199 60.1832C173.681 59.8555 173.305 59.382 173.073 58.7628C172.841 58.1409 172.797 57.3913 172.941 56.514C173.081 55.6651 173.358 54.9452 173.774 54.3543C174.189 53.7608 174.696 53.3093 175.295 52.9996C175.893 52.6874 176.537 52.5313 177.226 52.5313C177.941 52.5313 178.557 52.6964 179.076 53.0267C179.597 53.357 179.973 53.8344 180.202 54.4588C180.435 55.0806 180.479 55.8315 180.334 56.7114ZM178.666 56.514C178.756 55.9696 178.752 55.5128 178.654 55.1439C178.559 54.7723 178.383 54.491 178.128 54.3001C177.872 54.1092 177.55 54.0137 177.16 54.0137C176.737 54.0137 176.349 54.1195 175.995 54.3311C175.644 54.5426 175.348 54.8497 175.105 55.2522C174.865 55.6522 174.699 56.1386 174.606 56.7114C174.513 57.2584 174.515 57.7152 174.613 58.0816C174.714 58.448 174.893 58.7253 175.151 58.9137C175.412 59.0995 175.736 59.1924 176.123 59.1924C176.544 59.1924 176.928 59.0892 177.276 58.8827C177.627 58.6737 177.923 58.3706 178.163 57.9732C178.403 57.5732 178.57 57.0868 178.666 56.514ZM183.925 52.6397L182.609 60.5664H180.933L182.249 52.6397H183.925ZM191.934 52.6397L190.618 60.5664H189.17L186.558 55.5774H186.496L185.664 60.5664H183.988L185.304 52.6397H186.775L189.375 57.6248H189.441L190.266 52.6397H191.934ZM192.003 60.5664L193.319 52.6397H196.446C197.045 52.6397 197.537 52.7455 197.924 52.957C198.314 53.1686 198.588 53.4692 198.745 53.8589C198.905 54.2459 198.942 54.7026 198.857 55.229C198.769 55.7554 198.58 56.207 198.288 56.5837C197.999 56.9604 197.623 57.2507 197.158 57.4545C196.696 57.6558 196.161 57.7564 195.552 57.7564H193.458L193.69 56.4095H195.509C195.829 56.4095 196.103 56.3656 196.33 56.2779C196.557 56.1902 196.736 56.0586 196.868 55.8831C197.002 55.7077 197.09 55.4896 197.131 55.229C197.175 54.9632 197.159 54.7413 197.085 54.5633C197.01 54.3827 196.874 54.2459 196.678 54.153C196.482 54.0575 196.224 54.0098 195.904 54.0098H194.774L193.678 60.5664H192.003ZM196.879 56.9591L198.253 60.5664H196.403L195.072 56.9591H196.879ZM202.211 52.6397L200.895 60.5664H199.219L200.535 52.6397H202.211ZM207.503 54.9426C207.516 54.6201 207.422 54.3711 207.22 54.1956C207.022 54.0201 206.721 53.9324 206.319 53.9324C206.045 53.9324 205.808 53.9711 205.606 54.0485C205.405 54.1233 205.244 54.2279 205.123 54.362C205.004 54.4936 204.93 54.6459 204.902 54.8187C204.874 54.9607 204.883 55.0845 204.929 55.1903C204.978 55.2961 205.054 55.3877 205.157 55.4651C205.263 55.5399 205.388 55.6057 205.533 55.6625C205.677 55.7167 205.831 55.7631 205.993 55.8018L206.675 55.9721C207.007 56.0496 207.307 56.1528 207.573 56.2818C207.841 56.4108 208.065 56.5695 208.246 56.7579C208.429 56.9462 208.558 57.1681 208.633 57.4236C208.708 57.679 208.718 57.9719 208.664 58.3022C208.581 58.7873 208.389 59.2079 208.087 59.564C207.785 59.9175 207.389 60.1923 206.899 60.3884C206.409 60.5819 205.841 60.6787 205.196 60.6787C204.556 60.6787 204.016 60.5806 203.574 60.3845C203.133 60.1884 202.812 59.8981 202.611 59.5136C202.412 59.1266 202.353 58.6479 202.433 58.0777H204.054C204.026 58.3435 204.065 58.5654 204.17 58.7434C204.279 58.9189 204.44 59.0518 204.654 59.1421C204.868 59.2298 205.12 59.2737 205.409 59.2737C205.695 59.2737 205.95 59.2324 206.171 59.1498C206.396 59.0672 206.578 58.9524 206.717 58.8053C206.857 58.6583 206.942 58.4892 206.973 58.2983C207.004 58.1203 206.976 57.9706 206.891 57.8493C206.806 57.7281 206.669 57.6248 206.481 57.5397C206.295 57.452 206.064 57.3746 205.788 57.3075L204.96 57.0907C204.32 56.9282 203.836 56.674 203.509 56.3282C203.181 55.9825 203.063 55.5167 203.156 54.931C203.239 54.451 203.439 54.0317 203.756 53.6731C204.076 53.3118 204.479 53.0319 204.964 52.8332C205.452 52.6319 205.984 52.5313 206.562 52.5313C207.151 52.5313 207.647 52.6332 208.052 52.8371C208.458 53.0383 208.753 53.3196 208.939 53.6808C209.125 54.0421 209.181 54.4627 209.109 54.9426H207.503ZM209.416 60.5664L210.732 52.6397H216.073L215.841 54.0214H212.176L211.866 55.9102H215.256L215.024 57.292H211.634L211.324 59.1846H215.005L214.773 60.5664H209.416Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.147 86.8477L109.902 76.2787H113.772C114.522 76.2787 115.123 76.4025 115.574 76.6502C116.028 76.8945 116.341 77.2265 116.513 77.6462C116.685 78.0625 116.726 78.5321 116.637 79.0551C116.564 79.4955 116.422 79.8653 116.208 80.1646C115.998 80.4639 115.744 80.7048 115.444 80.8871C115.145 81.0695 114.83 81.2019 114.5 81.2845L114.479 81.3877C114.823 81.4049 115.145 81.5184 115.444 81.7283C115.747 81.9347 115.978 82.2289 116.136 82.6108C116.294 82.9927 116.33 83.4571 116.244 84.0041C116.152 84.5443 115.942 85.0294 115.615 85.4594C115.291 85.8861 114.846 86.2249 114.278 86.4761C113.711 86.7238 113.017 86.8477 112.198 86.8477H108.147ZM109.969 85.4801H112.271C113.034 85.4801 113.606 85.3321 113.984 85.0363C114.366 84.7404 114.596 84.3705 114.676 83.9267C114.727 83.593 114.691 83.2868 114.567 83.0081C114.447 82.7295 114.244 82.5076 113.958 82.3424C113.676 82.1773 113.322 82.0947 112.895 82.0947H110.537L109.969 85.4801ZM110.748 80.851H112.88C113.237 80.851 113.571 80.7822 113.881 80.6446C114.194 80.507 114.454 80.3126 114.66 80.0614C114.87 79.8103 115.001 79.5161 115.052 79.1789C115.128 78.7386 115.037 78.3722 114.779 78.0797C114.524 77.7839 114.082 77.6359 113.452 77.6359H111.275L110.748 80.851ZM117.656 86.8477L119.41 76.2787H126.037L125.81 77.6514H120.778L120.241 80.8716H124.927L124.7 82.2392H120.014L119.478 85.4749H124.571L124.344 86.8477H117.656ZM133.456 79.117C133.46 78.5975 133.291 78.2001 132.951 77.9249C132.614 77.6497 132.142 77.5121 131.537 77.5121C131.103 77.5121 130.716 77.5809 130.376 77.7185C130.038 77.8527 129.763 78.0384 129.55 78.2758C129.34 78.5098 129.211 78.7764 129.163 79.0757C129.118 79.3269 129.14 79.5436 129.23 79.726C129.323 79.9083 129.455 80.0614 129.627 80.1853C129.803 80.3057 129.995 80.4072 130.205 80.4897C130.415 80.5689 130.618 80.6342 130.814 80.6859L131.805 80.9542C132.125 81.0368 132.45 81.1486 132.78 81.2896C133.111 81.4307 133.408 81.6165 133.673 81.847C133.938 82.0775 134.136 82.3631 134.267 82.7037C134.397 83.0443 134.423 83.452 134.344 83.9267C134.241 84.5254 133.998 85.0569 133.616 85.5214C133.235 85.9858 132.73 86.3522 132.104 86.6206C131.478 86.8889 130.752 87.0231 129.927 87.0231C129.135 87.0231 128.47 86.8975 127.929 86.6464C127.393 86.3952 126.999 86.0392 126.748 85.5781C126.496 85.1137 126.407 84.5632 126.479 83.9267H128.084C128.046 84.3086 128.115 84.6269 128.291 84.8815C128.47 85.1326 128.721 85.3201 129.044 85.444C129.367 85.5644 129.734 85.6246 130.143 85.6246C130.597 85.6246 131.012 85.5541 131.387 85.413C131.762 85.2685 132.072 85.069 132.316 84.8144C132.56 84.5563 132.71 84.2553 132.765 83.9113C132.82 83.5982 132.775 83.3419 132.631 83.1423C132.49 82.9428 132.276 82.7776 131.991 82.6469C131.709 82.5162 131.387 82.4009 131.026 82.3011L129.834 81.9605C129.025 81.73 128.413 81.3911 127.996 80.9439C127.58 80.4966 127.431 79.9049 127.547 79.1686C127.651 78.5597 127.905 78.0281 128.311 77.574C128.717 77.1199 129.223 76.7672 129.828 76.5161C130.434 76.2615 131.091 76.1342 131.8 76.1342C132.515 76.1342 133.124 76.2615 133.627 76.5161C134.129 76.7706 134.501 77.1216 134.741 77.5688C134.982 78.0161 135.067 78.5321 134.994 79.117H133.456ZM136.771 77.6514L136.998 76.2787H145.178L144.95 77.6514H141.653L140.125 86.8477H138.536L140.063 77.6514H136.771ZM159.362 76.2787L157.607 86.8477H156.141L152.059 79.0964H151.966L150.671 86.8477H149.076L150.831 76.2787H152.307L156.394 84.0403H156.492L157.782 76.2787H159.362ZM159.933 86.8477L161.688 76.2787H168.314L168.087 77.6514H163.055L162.519 80.8716H167.204L166.977 82.2392H162.291L161.755 85.4749H166.848L166.621 86.8477H159.933ZM170.759 86.8477L169.582 76.2787H171.259L171.961 84.4634H172.059L175.558 76.2787H177.22L178.004 84.4686H178.108L181.514 76.2787H183.196L178.505 86.8477H176.9L175.997 78.9312H175.914L172.369 86.8477H170.759ZM187.748 77.6514L187.975 76.2787H196.154L195.927 77.6514H192.63L191.102 86.8477H189.513L191.04 77.6514H187.748ZM196.207 86.8477L197.962 76.2787H201.729C202.548 76.2787 203.203 76.4197 203.695 76.7018C204.191 76.9805 204.531 77.3693 204.717 77.8681C204.906 78.3636 204.948 78.9381 204.841 79.5918C204.731 80.2386 204.499 80.8063 204.144 81.2948C203.793 81.7833 203.324 82.1652 202.735 82.4405C202.151 82.7123 201.449 82.8482 200.63 82.8482H197.776L198.013 81.4754H200.723C201.242 81.4754 201.676 81.4015 202.023 81.2535C202.371 81.1056 202.643 80.8906 202.839 80.6084C203.038 80.3263 203.169 79.9874 203.231 79.5918C203.296 79.1893 203.277 78.8435 203.174 78.5545C203.071 78.2621 202.87 78.0384 202.57 77.8836C202.271 77.7254 201.86 77.6462 201.337 77.6462H199.335L197.802 86.8477H196.207ZM202.214 82.0792L204.036 86.8477H202.219L200.444 82.0792H202.214ZM206.509 86.8477H204.816L210.374 76.2787H212.217L214.266 86.8477H212.573L211.03 78.1984H210.947L206.509 86.8477ZM207.479 82.7088H212.97L212.743 84.0506H207.252L207.479 82.7088ZM219.26 86.8477H215.792L217.546 76.2787H221.03C222.069 76.2787 222.927 76.4954 223.605 76.9289C224.283 77.359 224.758 77.9748 225.029 78.7764C225.301 79.5746 225.344 80.5293 225.158 81.6406C224.979 82.7277 224.629 83.6601 224.106 84.4376C223.586 85.2117 222.917 85.8069 222.098 86.2232C221.279 86.6395 220.333 86.8477 219.26 86.8477ZM217.624 85.4543H219.327C220.132 85.4543 220.829 85.2977 221.417 84.9847C222.009 84.6716 222.489 84.2175 222.857 83.6223C223.225 83.0271 223.479 82.3029 223.621 81.4496C223.758 80.6377 223.746 79.9513 223.584 79.3905C223.423 78.8263 223.11 78.3997 222.645 78.1107C222.181 77.8183 221.563 77.672 220.792 77.672H218.909L217.624 85.4543ZM229.629 76.2787L227.874 86.8477H226.28L228.034 76.2787H229.629ZM240.482 76.2787L238.727 86.8477H237.261L233.179 79.0964H233.086L231.791 86.8477H230.196L231.951 76.2787H233.427L237.514 84.0403H237.612L238.902 76.2787H240.482ZM249.398 79.6176C249.353 79.3045 249.274 79.0241 249.161 78.7764C249.05 78.5253 248.901 78.312 248.712 78.1365C248.522 77.961 248.295 77.8269 248.03 77.734C247.765 77.6376 247.458 77.5895 247.107 77.5895C246.508 77.5895 245.935 77.7426 245.388 78.0488C244.845 78.355 244.377 78.8039 243.984 79.3957C243.592 79.984 243.326 80.7048 243.185 81.558C243.04 82.4147 243.05 83.1389 243.215 83.7306C243.381 84.3224 243.673 84.7714 244.093 85.0776C244.513 85.3838 245.032 85.5369 245.651 85.5369C246.226 85.5369 246.754 85.4199 247.236 85.1859C247.717 84.952 248.118 84.6217 248.438 84.1951C248.761 83.765 248.97 83.2593 249.062 82.6779L249.46 82.7553H246.436L246.663 81.4393H250.822L250.611 82.6417C250.47 83.5328 250.157 84.3052 249.671 84.9589C249.186 85.6091 248.583 86.1114 247.86 86.4658C247.141 86.8167 246.353 86.9922 245.496 86.9922C244.54 86.9922 243.738 86.772 243.092 86.3316C242.445 85.8912 241.987 85.2668 241.719 84.4583C241.454 83.6463 241.414 82.683 241.6 81.5683C241.734 80.7254 241.973 79.9685 242.318 79.2976C242.665 78.6268 243.09 78.0574 243.592 77.5895C244.095 77.1181 244.654 76.7586 245.269 76.5109C245.889 76.2597 246.539 76.1342 247.22 76.1342C247.791 76.1342 248.309 76.2185 248.773 76.387C249.241 76.5556 249.644 76.7947 249.981 77.1044C250.318 77.414 250.578 77.7821 250.76 78.2087C250.943 78.6319 251.034 79.1015 251.034 79.6176H249.398ZM138.851 104.848L140.606 94.2787H144.373C145.192 94.2787 145.846 94.4283 146.334 94.7276C146.826 95.027 147.163 95.4346 147.346 95.9507C147.531 96.4668 147.571 97.0499 147.464 97.7002C147.354 98.3504 147.12 98.9353 146.762 99.4548C146.408 99.9709 145.935 100.38 145.343 100.683C144.752 100.982 144.048 101.132 143.233 101.132H140.637L140.859 99.7799H143.305C143.824 99.7799 144.261 99.6905 144.616 99.5116C144.973 99.3292 145.254 99.0815 145.457 98.7684C145.66 98.4519 145.792 98.0958 145.854 97.7002C145.92 97.2976 145.902 96.9433 145.803 96.6371C145.703 96.3274 145.505 96.0849 145.209 95.9094C144.917 95.734 144.507 95.6462 143.981 95.6462H141.979L140.446 104.848H138.851ZM148.118 104.848L149.873 94.2787H151.468L149.94 103.475H154.729L154.502 104.848H148.118ZM157.753 104.848H156.061L161.619 94.2787H163.461L165.51 104.848H163.817L162.274 96.1984H162.192L157.753 104.848ZM158.724 100.709H164.214L163.987 102.051H158.496L158.724 100.709ZM166.793 95.6514L167.021 94.2787H175.2L174.973 95.6514H171.675L170.148 104.848H168.558L170.086 95.6514H166.793ZM175.253 104.848L177.008 94.2787H183.562L183.335 95.6514H178.375L177.839 98.8716H182.328L182.101 100.239H177.611L176.848 104.848H175.253ZM193.811 99.6664C193.625 100.778 193.264 101.731 192.727 102.525C192.194 103.32 191.54 103.931 190.766 104.357C189.995 104.781 189.163 104.992 188.268 104.992C187.336 104.992 186.539 104.77 185.879 104.326C185.222 103.879 184.75 103.244 184.465 102.422C184.179 101.596 184.131 100.612 184.32 99.4703C184.506 98.359 184.866 97.406 185.399 96.6113C185.936 95.8131 186.591 95.2007 187.365 94.7741C188.143 94.3475 188.982 94.1342 189.883 94.1342C190.809 94.1342 191.599 94.3578 192.252 94.8051C192.909 95.2489 193.381 95.8853 193.666 96.7145C193.952 97.5402 194 98.5242 193.811 99.6664ZM192.257 99.4703C192.398 98.6274 192.381 97.9186 192.206 97.3441C192.034 96.7661 191.74 96.3292 191.323 96.0333C190.907 95.7374 190.405 95.5895 189.816 95.5895C189.19 95.5895 188.604 95.7477 188.057 96.0642C187.513 96.3808 187.049 96.8418 186.663 97.4473C186.278 98.0528 186.015 98.7925 185.874 99.6664C185.729 100.509 185.745 101.218 185.92 101.793C186.096 102.367 186.391 102.802 186.808 103.098C187.227 103.391 187.732 103.537 188.32 103.537C188.943 103.537 189.526 103.38 190.069 103.067C190.616 102.751 191.082 102.291 191.468 101.689C191.853 101.084 192.116 100.344 192.257 99.4703ZM194.937 104.848L196.692 94.2787H200.459C201.278 94.2787 201.933 94.4197 202.425 94.7018C202.921 94.9805 203.261 95.3693 203.447 95.8681C203.636 96.3636 203.677 96.9381 203.571 97.5918C203.461 98.2386 203.228 98.8063 202.874 99.2948C202.523 99.7833 202.054 100.165 201.465 100.44C200.88 100.712 200.179 100.848 199.36 100.848H196.506L196.743 99.4754H199.453C199.972 99.4754 200.406 99.4015 200.753 99.2535C201.101 99.1056 201.372 98.8906 201.568 98.6084C201.768 98.3263 201.899 97.9874 201.961 97.5918C202.026 97.1893 202.007 96.8435 201.904 96.5545C201.801 96.2621 201.599 96.0384 201.3 95.8836C201.001 95.7254 200.59 95.6462 200.067 95.6462H198.064L196.532 104.848H194.937ZM200.944 100.079L202.766 104.848H200.949L199.174 100.079H200.944ZM206.101 94.2787H208.036L210.049 102.494H210.173L214.889 94.2787H216.825L215.07 104.848H213.553L214.827 97.1996H214.729L210.343 104.832H209.078L207.241 97.1944H207.143L205.863 104.848H204.346L206.101 94.2787ZM161.79 121.848L161.991 120.692L166.171 116.986C166.618 116.584 166.992 116.231 167.291 115.928C167.594 115.622 167.829 115.331 167.998 115.056C168.17 114.781 168.283 114.489 168.338 114.179C168.397 113.828 168.366 113.525 168.246 113.271C168.129 113.013 167.941 112.815 167.683 112.677C167.425 112.536 167.115 112.466 166.754 112.466C166.376 112.466 166.032 112.543 165.722 112.698C165.412 112.853 165.154 113.071 164.948 113.353C164.742 113.635 164.606 113.966 164.54 114.344H163.023C163.13 113.701 163.374 113.138 163.756 112.657C164.138 112.175 164.611 111.802 165.175 111.537C165.739 111.268 166.35 111.134 167.007 111.134C167.674 111.134 168.237 111.267 168.695 111.532C169.156 111.793 169.489 112.151 169.696 112.605C169.902 113.056 169.957 113.565 169.861 114.133C169.792 114.528 169.653 114.913 169.443 115.288C169.233 115.66 168.91 116.076 168.473 116.537C168.036 116.995 167.441 117.551 166.687 118.204L164.231 120.403L164.215 120.48H168.968L168.746 121.848H161.79ZM174.356 122.023C173.54 122.023 172.88 121.81 172.374 121.383C171.868 120.953 171.531 120.33 171.363 119.515C171.194 118.7 171.203 117.717 171.388 116.568C171.578 115.423 171.892 114.444 172.333 113.632C172.777 112.82 173.322 112.201 173.969 111.774C174.619 111.347 175.348 111.134 176.157 111.134C176.962 111.134 177.619 111.349 178.128 111.779C178.637 112.206 178.98 112.823 179.155 113.632C179.334 114.44 179.327 115.419 179.135 116.568C178.942 117.721 178.625 118.703 178.185 119.515C177.745 120.327 177.199 120.948 176.549 121.378C175.899 121.808 175.168 122.023 174.356 122.023ZM174.583 120.645C175.302 120.645 175.921 120.296 176.441 119.598C176.96 118.899 177.33 117.889 177.55 116.568C177.695 115.691 177.724 114.95 177.638 114.344C177.555 113.735 177.368 113.274 177.075 112.961C176.786 112.645 176.405 112.486 175.93 112.486C175.221 112.486 174.605 112.839 174.082 113.544C173.563 114.246 173.195 115.254 172.978 116.568C172.83 117.449 172.797 118.194 172.88 118.803C172.962 119.408 173.148 119.868 173.437 120.181C173.726 120.49 174.108 120.645 174.583 120.645ZM180.083 121.848L180.284 120.692L184.464 116.986C184.911 116.584 185.285 116.231 185.584 115.928C185.887 115.622 186.122 115.331 186.291 115.056C186.463 114.781 186.577 114.489 186.632 114.179C186.69 113.828 186.659 113.525 186.539 113.271C186.422 113.013 186.234 112.815 185.976 112.677C185.718 112.536 185.409 112.466 185.047 112.466C184.669 112.466 184.325 112.543 184.015 112.698C183.706 112.853 183.448 113.071 183.241 113.353C183.035 113.635 182.899 113.966 182.833 114.344H181.316C181.423 113.701 181.667 113.138 182.049 112.657C182.431 112.175 182.904 111.802 183.468 111.537C184.032 111.268 184.643 111.134 185.3 111.134C185.968 111.134 186.53 111.267 186.988 111.532C187.449 111.793 187.782 112.151 187.989 112.605C188.195 113.056 188.25 113.565 188.154 114.133C188.085 114.528 187.946 114.913 187.736 115.288C187.526 115.66 187.203 116.076 186.766 116.537C186.329 116.995 185.734 117.551 184.98 118.204L182.524 120.403L182.508 120.48H187.261L187.039 121.848H180.083ZM192.463 121.992C191.816 121.992 191.256 121.867 190.781 121.615C190.306 121.364 189.952 121.02 189.718 120.583C189.484 120.146 189.403 119.649 189.475 119.092H191.023C190.989 119.543 191.13 119.916 191.447 120.212C191.763 120.504 192.174 120.65 192.68 120.65C193.086 120.65 193.463 120.557 193.81 120.372C194.158 120.182 194.448 119.924 194.682 119.598C194.92 119.267 195.074 118.889 195.147 118.462C195.216 118.032 195.185 117.649 195.054 117.311C194.923 116.974 194.711 116.709 194.419 116.517C194.127 116.321 193.769 116.223 193.346 116.223C193.029 116.223 192.701 116.279 192.36 116.393C192.019 116.503 191.732 116.646 191.498 116.821L190.074 116.604L191.555 111.279H197.366L197.144 112.646H192.659L191.828 115.603H191.89C192.135 115.4 192.437 115.233 192.799 115.103C193.16 114.969 193.538 114.901 193.934 114.901C194.577 114.901 195.126 115.055 195.58 115.361C196.034 115.667 196.361 116.085 196.561 116.615C196.764 117.145 196.807 117.75 196.69 118.431C196.58 119.116 196.325 119.727 195.926 120.263C195.527 120.8 195.028 121.223 194.429 121.533C193.831 121.839 193.175 121.992 192.463 121.992Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 249,
    y: 123,
    width: 35,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.344 123.621H283.788V153.573H249.344V123.621Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 249,
    y: 123,
    width: 35,
    height: 31
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M258.836 148.718C260.663 143.404 263.756 130.23 252.339 123.875C252.339 123.875 243.609 143.628 257.6 150.839C270.677 159.585 283.755 142.392 283.755 142.392C272.666 135.489 262.606 144.553 258.836 148.718Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.756 123.875V159.585H243.609V123.875H283.756Z",
    fill: "url(#paint0_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 237,
    y: 134,
    width: 34,
    height: 34
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.859 134.605H270.806V167.053H237.859V134.605Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 237,
    y: 135,
    width: 34,
    height: 32
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.975 160.679C247.826 155.839 253.508 143.533 243.594 135.023C243.594 135.023 231.078 152.626 243.333 162.489C254.393 173.686 270.656 159.455 270.656 159.455C261.181 150.459 249.503 157.353 244.975 160.679Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.672 135.023V173.684H231.094V135.023H270.672Z",
    fill: "url(#paint1_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 257,
    y: 112,
    width: 34,
    height: 26
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.844 112.641H290.291V137.6H257.844V112.641Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 258,
    y: 112,
    width: 33,
    height: 26
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268.825 134.243C269.628 129.193 270.334 116.863 259.088 112.953C259.088 112.953 254.354 132.053 268.045 136.328C281.156 142.105 290.192 124.645 290.192 124.645C279.156 120.18 271.553 129.914 268.825 134.243Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.19 112.953V142.105H254.352V112.953H290.19Z",
    fill: "url(#paint2_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 101,
    width: 33,
    height: 22
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M263.32 101.16H295.269V122.626H263.32V101.16Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 101,
    width: 33,
    height: 22
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M276.554 119.892C276.472 114.964 275.086 103.165 263.776 101.328C263.776 101.328 262.469 120.221 276.154 121.994C289.551 125.311 295.2 107.233 295.2 107.233C283.995 104.813 278.414 115.304 276.554 119.892Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.207 101.328V125.311H262.477V101.328H295.207Z",
    fill: "url(#paint3_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 87,
    width: 31,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M266.312 87.6797H296.759V107.148H266.312V87.6797Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 88,
    width: 31,
    height: 20
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M279.957 104.821C279.559 100.164 277.459 89.0765 266.625 88.0664C266.625 88.0664 266.625 106.045 279.721 106.819C292.63 109.095 296.781 91.5842 296.781 91.5842C286.012 90.0768 281.419 100.382 279.957 104.821Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.781 88.0664V109.095H266.625V88.0664H296.781Z",
    fill: "url(#paint4_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 74,
    width: 27,
    height: 18
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M266.312 74.7031H292.77V91.1765H266.312V74.7031Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 74,
    width: 27,
    height: 17
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.833 88.989C279.676 85.169 275.913 76.2771 266.68 77.3983C266.68 77.3983 269.928 92.421 281 90.7225C292.193 90.2818 292.517 74.9141 292.517 74.9141C283.237 75.5732 281.254 85.013 280.833 88.989Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.517 74.9141V92.421H266.68V74.9141H292.517Z",
    fill: "url(#paint5_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 61,
    width: 24,
    height: 18
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M265.367 61.7266H288.33V78.2H265.367V61.7266Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 62,
    width: 24,
    height: 16
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M279.413 75.8586C277.933 72.6002 273.604 65.1298 265.539 67.1929C265.539 67.1929 270.129 80.168 279.766 77.401C289.658 75.7494 288.202 62.0625 288.202 62.0625C280.027 63.679 279.339 72.2823 279.413 75.8586Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.658 62.0625V80.168H265.539V62.0625H289.658Z",
    fill: "url(#paint6_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 51,
    width: 20,
    height: 16
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M263.844 51.7383H282.314V66.7141H263.844V51.7383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 52,
    width: 20,
    height: 15
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M276.248 64.4802C274.651 62.0193 270.228 56.5087 263.938 59.149C263.938 59.149 269.251 69.0919 276.716 65.6658C284.52 63.1172 281.665 52.2148 281.665 52.2148C275.253 54.5431 275.75 61.5923 276.248 64.4802Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.52 52.2148V69.0919H263.938V52.2148H284.52Z",
    fill: "url(#paint7_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 260,
    y: 42,
    width: 18,
    height: 16
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M260.32 42.7578H277.792V57.2344H260.32V42.7578Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 260,
    y: 43,
    width: 18,
    height: 15
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M272.545 55.0645C270.811 52.9449 266.048 48.2767 260.461 51.4298C260.461 51.4298 266.516 60.1364 273.112 56.1214C280.119 52.8806 276.258 43.0117 276.258 43.0117C270.538 45.8899 271.783 52.4243 272.545 55.0645Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.119 43.0117V60.1364H260.461V43.0117H280.119Z",
    fill: "url(#paint8_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 34,
    width: 17,
    height: 16
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M255.836 34.7695H271.81V49.2462H255.836V34.7695Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 256,
    y: 35,
    width: 16,
    height: 15
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.854 46.7761C265.994 44.9743 261.09 41.0861 256.188 44.6038C256.188 44.6038 262.728 52.1152 268.492 47.7063C274.718 43.9682 270.104 35.1289 270.104 35.1289C265.035 38.399 266.854 44.3854 267.854 46.7761Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.718 35.1289V52.1152H256.188V35.1289H274.718Z",
    fill: "url(#paint9_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 253,
    y: 30,
    width: 13,
    height: 13
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M253.344 30.2734H265.824V42.2541H253.344V30.2734Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 253,
    y: 30,
    width: 13,
    height: 13
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M262.915 39.8171C261.271 38.6608 257.045 36.1823 253.664 39.4525C253.664 39.4525 259.561 44.5321 263.492 40.4645C267.879 36.8765 263.318 30.5664 263.318 30.5664C259.785 33.6649 261.868 38.0836 262.915 39.8171Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.879 30.5664V44.5321H253.664V30.5664H267.879Z",
    fill: "url(#paint10_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 26,
    width: 15,
    height: 11
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M246.875 26.2812H260.353V36.2651H246.875V26.2812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 247,
    y: 26,
    width: 13,
    height: 11
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M259.839 36.1587C259.839 36.1587 252.681 37.7869 247.195 26.3873C247.195 26.3873 256.573 24.7065 259.839 36.1587Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.839 24.7031V37.7836H247.195V24.7031H259.839Z",
    fill: "url(#paint11_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 123,
    width: 36,
    height: 31
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.43 123.625H73.9853V153.577H108.43V123.625Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 123,
    width: 35,
    height: 31
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M98.945 148.726C97.1178 143.412 94.0252 130.238 105.442 123.883C105.442 123.883 114.172 143.636 100.181 150.847C87.1047 159.593 74.0262 142.4 74.0262 142.4C85.1157 135.497 95.1757 144.56 98.945 148.726Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0023 123.883V159.593H114.148V123.883H74.0023Z",
    fill: "url(#paint12_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 134,
    width: 34,
    height: 34
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M119.898 134.605H86.9516V167.053H119.898V134.605Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 135,
    width: 33,
    height: 32
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M112.775 160.679C109.924 155.839 104.242 143.533 114.156 135.023C114.156 135.023 126.672 152.626 114.417 162.489C103.357 173.686 87.0938 159.455 87.0938 159.455C96.5687 150.459 108.247 157.353 112.775 160.679Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.0776 135.023V173.684H126.656V135.023H87.0776Z",
    fill: "url(#paint13_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 112,
    width: 33,
    height: 26
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9219 112.641H67.4742V137.6H99.9219V112.641Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 112,
    width: 33,
    height: 26
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9567 134.243C88.1533 129.193 87.4474 116.863 98.6929 112.953C98.6929 112.953 103.427 132.053 89.7367 136.328C76.625 142.105 67.5888 124.645 67.5888 124.645C78.6257 120.18 86.2287 129.914 88.9567 134.243Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5989 112.953V142.105H103.438V112.953H67.5989Z",
    fill: "url(#paint14_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 101,
    width: 33,
    height: 22
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4297 101.16H62.4813V122.626H94.4297V101.16Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 101,
    width: 33,
    height: 22
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2038 119.892C81.2857 114.964 82.6722 103.165 93.982 101.328C93.982 101.328 95.2885 120.221 81.6036 121.994C68.2072 125.311 62.5582 107.233 62.5582 107.233C73.7627 104.813 79.3436 115.304 81.2038 119.892Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5587 101.328V125.311H95.2891V101.328H62.5587Z",
    fill: "url(#paint15_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 87,
    width: 31,
    height: 21
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4531 87.6797H61.0062V107.148H91.4531V87.6797Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 88,
    width: 32,
    height: 20
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8008 104.825C78.1986 100.168 80.2987 89.0804 91.1328 88.0703C91.1328 88.0703 91.1328 106.049 78.0368 106.823C65.1279 109.099 60.9764 91.5881 60.9764 91.5881C71.7461 90.0807 76.3383 100.386 77.8008 104.825Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9764 88.0703V109.099H91.1328V88.0703H60.9764Z",
    fill: "url(#paint16_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 74,
    width: 28,
    height: 18
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4531 74.7031H64.9958V91.1765H91.4531V74.7031Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 74,
    width: 27,
    height: 17
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9174 88.989C78.0737 85.169 81.8372 76.2771 91.0703 77.3983C91.0703 77.3983 87.8216 92.421 76.7497 90.7225C65.5568 90.2818 65.2331 74.9141 65.2331 74.9141C74.5131 75.5732 76.4962 85.013 76.9174 88.989Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2331 74.9141V92.421H91.0703V74.9141H65.2331Z",
    fill: "url(#paint17_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 61,
    width: 24,
    height: 18
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4219 61.7266H69.4589V78.2H92.4219V61.7266Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 62,
    width: 24,
    height: 16
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3525 75.8586C79.8325 72.6002 84.1615 65.1298 92.2266 67.1929C92.2266 67.1929 87.6363 80.168 77.9995 77.401C68.1073 75.7494 69.5639 62.0625 69.5639 62.0625C77.7382 63.679 78.4266 72.2823 78.3525 75.8586Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1073 62.0625V80.168H92.2266V62.0625H68.1073Z",
    fill: "url(#paint18_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 51,
    width: 19,
    height: 16
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8984 51.7383H75.4282V66.7141H93.8984V51.7383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 52,
    width: 19,
    height: 15
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4945 64.4763C83.0915 62.0154 87.5141 56.5048 93.8047 59.1451C93.8047 59.1451 88.491 69.088 81.0265 65.6619C73.2227 63.1133 76.0774 52.2109 76.0774 52.2109C82.489 54.5392 81.9917 61.5884 81.4945 64.4763Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2227 52.2109V69.088H93.8047V52.2109H73.2227Z",
    fill: "url(#paint19_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 42,
    width: 19,
    height: 16
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4297 42.7578H79.9579V57.2344H97.4297V42.7578Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 43,
    width: 18,
    height: 15
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2285 55.0645C86.962 52.9449 91.7258 48.2767 97.3125 51.4298C97.3125 51.4298 91.2578 60.1364 84.661 56.1214C77.6548 52.8806 81.5157 43.0117 81.5157 43.0117C87.235 45.8899 85.9909 52.4243 85.2285 55.0645Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6548 43.0117V60.1364H97.3125V43.0117H77.6548Z",
    fill: "url(#paint20_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 34,
    width: 17,
    height: 16
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M101.93 34.7695H85.9555V49.2462H101.93V34.7695Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 35,
    width: 16,
    height: 15
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9036 46.7761C91.7639 44.9743 96.6681 41.0861 101.57 44.6038C101.57 44.6038 95.0301 52.1152 89.266 47.7063C83.0397 43.9682 87.6533 35.1289 87.6533 35.1289C92.7233 38.399 90.9039 44.3854 89.9036 46.7761Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.0397 35.1289V52.1152H101.57V35.1289H83.0397Z",
    fill: "url(#paint21_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 30,
    width: 14,
    height: 13
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M104.406 30.2734H91.9264V42.2541H104.406V30.2734Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 30,
    width: 13,
    height: 13
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8587 39.8171C96.5025 38.6608 100.728 36.1823 104.109 39.4525C104.109 39.4525 98.2126 44.5321 94.2815 40.4645C89.894 36.8765 94.455 30.5664 94.455 30.5664C97.9884 33.6649 95.9058 38.0836 94.8587 39.8171Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.894 30.5664V44.5321H104.109V30.5664H89.894Z",
    fill: "url(#paint22_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 26,
    width: 14,
    height: 11
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M110.875 26.2812H97.3968V36.2651H110.875V26.2812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 26,
    width: 14,
    height: 11
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8876 36.1587C97.8876 36.1587 105.046 37.7869 110.531 26.3873C110.531 26.3873 101.154 24.7065 97.8876 36.1587Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.8876 24.7031V37.7836H110.531V24.7031H97.8876Z",
    fill: "url(#paint23_linear_1660_11690)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 130,
    width: 46,
    height: 43
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M156.984 130.352H201.413V172.783H156.984V130.352Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 130,
    width: 45,
    height: 43
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M179.258 130.852L186.028 144.556L201.166 146.75L190.209 157.422L192.792 172.484L179.258 165.372L165.719 172.484L168.303 157.422L157.352 146.75L172.489 144.556L179.258 130.852Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.469 130.852V172.484H201.283V130.852H157.469Z",
    fill: "url(#paint24_linear_1660_11690)"
  })))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M179.463 330.801L181.316 334.551L185.458 335.151L182.46 338.071L183.167 342.193L179.463 340.247L175.758 342.193L176.465 338.071L173.469 335.151L177.611 334.551L179.463 330.801Z",
    fill: "#7C7C7C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 199.281,
    width: 125.705,
    height: 289.921,
    fill: "url(#pattern0_1660_11690)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M164.107 319.75L164.589 316.841H165.655C165.861 316.841 166.027 316.875 166.151 316.943C166.276 317.01 166.362 317.102 166.409 317.217C166.456 317.332 166.468 317.461 166.443 317.605C166.423 317.726 166.384 317.828 166.325 317.911C166.268 317.993 166.197 318.059 166.115 318.109C166.033 318.16 165.946 318.196 165.855 318.219L165.849 318.247C165.944 318.252 166.033 318.283 166.115 318.341C166.198 318.398 166.262 318.479 166.305 318.584C166.349 318.689 166.359 318.817 166.335 318.967C166.31 319.116 166.252 319.25 166.162 319.368C166.073 319.485 165.95 319.579 165.794 319.648C165.638 319.716 165.447 319.75 165.222 319.75H164.107ZM164.608 319.374H165.241C165.452 319.374 165.609 319.333 165.713 319.251C165.818 319.17 165.882 319.068 165.903 318.946C165.918 318.854 165.908 318.77 165.874 318.693C165.84 318.616 165.785 318.555 165.706 318.51C165.628 318.464 165.531 318.442 165.413 318.442H164.764L164.608 319.374ZM164.822 318.099H165.409C165.508 318.099 165.599 318.08 165.685 318.043C165.771 318.005 165.842 317.951 165.899 317.882C165.957 317.813 165.993 317.732 166.007 317.639C166.028 317.518 166.003 317.417 165.932 317.337C165.862 317.255 165.74 317.214 165.567 317.214H164.967L164.822 318.099ZM166.724 319.75L167.207 316.841H169.031L168.968 317.219H167.583L167.435 318.105H168.725L168.663 318.482H167.373L167.225 319.372H168.627L168.565 319.75H166.724ZM171.073 317.622C171.074 317.479 171.027 317.37 170.934 317.294C170.841 317.218 170.711 317.18 170.544 317.18C170.425 317.18 170.319 317.199 170.225 317.237C170.132 317.274 170.056 317.325 169.998 317.391C169.94 317.455 169.904 317.528 169.891 317.611C169.879 317.68 169.885 317.74 169.909 317.79C169.935 317.84 169.971 317.882 170.019 317.916C170.067 317.949 170.12 317.977 170.178 318C170.236 318.022 170.292 318.04 170.346 318.054L170.618 318.128C170.706 318.151 170.796 318.181 170.887 318.22C170.978 318.259 171.06 318.31 171.132 318.374C171.205 318.437 171.26 318.516 171.296 318.609C171.332 318.703 171.339 318.815 171.317 318.946C171.289 319.111 171.222 319.257 171.117 319.385C171.012 319.513 170.873 319.614 170.701 319.688C170.528 319.761 170.328 319.798 170.101 319.798C169.883 319.798 169.7 319.764 169.551 319.695C169.404 319.625 169.295 319.527 169.226 319.401C169.157 319.273 169.132 319.121 169.152 318.946H169.594C169.584 319.051 169.603 319.139 169.651 319.209C169.7 319.278 169.769 319.33 169.858 319.364C169.947 319.397 170.048 319.413 170.161 319.413C170.286 319.413 170.4 319.394 170.503 319.355C170.606 319.315 170.692 319.26 170.759 319.19C170.826 319.119 170.867 319.036 170.882 318.942C170.898 318.856 170.885 318.785 170.846 318.73C170.807 318.675 170.748 318.63 170.669 318.594C170.592 318.558 170.503 318.526 170.404 318.499L170.076 318.405C169.853 318.341 169.685 318.248 169.57 318.125C169.455 318.002 169.414 317.839 169.446 317.636C169.475 317.469 169.545 317.322 169.657 317.197C169.768 317.072 169.908 316.975 170.074 316.906C170.241 316.836 170.422 316.801 170.617 316.801C170.814 316.801 170.981 316.836 171.12 316.906C171.258 316.976 171.36 317.073 171.426 317.196C171.493 317.319 171.516 317.461 171.496 317.622H171.073ZM171.985 317.219L172.048 316.841H174.299L174.236 317.219H173.329L172.908 319.75H172.471L172.891 317.219H171.985ZM175.649 317.219L175.712 316.841H177.963L177.901 317.219H176.993L176.572 319.75H176.135L176.555 317.219H175.649ZM177.978 319.75L178.461 316.841H179.498C179.723 316.841 179.903 316.88 180.039 316.957C180.175 317.034 180.269 317.141 180.32 317.278C180.372 317.415 180.383 317.573 180.354 317.753C180.324 317.931 180.26 318.087 180.162 318.222C180.066 318.356 179.936 318.461 179.774 318.537C179.614 318.612 179.42 318.649 179.195 318.649H178.409L178.475 318.271H179.221C179.364 318.271 179.483 318.251 179.578 318.21C179.674 318.17 179.749 318.11 179.803 318.033C179.858 317.955 179.894 317.862 179.911 317.753C179.929 317.642 179.924 317.547 179.895 317.467C179.867 317.387 179.811 317.325 179.729 317.283C179.647 317.239 179.533 317.217 179.39 317.217H178.838L178.417 319.75H177.978ZM179.631 318.438L180.132 319.75H179.632L179.144 318.438H179.631ZM180.813 319.75H180.347L181.877 316.841H182.384L182.948 319.75H182.482L182.058 317.369H182.035L180.813 319.75ZM181.08 318.611H182.592L182.529 318.98H181.018L181.08 318.611ZM184.323 319.75H183.368L183.851 316.841H184.81C185.096 316.841 185.332 316.901 185.519 317.02C185.705 317.138 185.836 317.308 185.911 317.528C185.986 317.748 185.998 318.011 185.946 318.317C185.897 318.616 185.801 318.873 185.657 319.087C185.514 319.3 185.329 319.464 185.104 319.578C184.879 319.693 184.618 319.75 184.323 319.75ZM183.873 319.366H184.341C184.563 319.366 184.755 319.323 184.917 319.237C185.079 319.151 185.212 319.026 185.313 318.862C185.414 318.698 185.484 318.499 185.523 318.264C185.561 318.041 185.558 317.852 185.513 317.697C185.469 317.542 185.382 317.425 185.255 317.345C185.127 317.265 184.957 317.224 184.745 317.224H184.226L183.873 319.366ZM187.177 316.841L186.694 319.75H186.255L186.738 316.841H187.177ZM190.164 316.841L189.681 319.75H189.278L188.154 317.616H188.129L187.772 319.75H187.333L187.816 316.841H188.222L189.347 318.977H189.374L189.729 316.841H190.164ZM192.618 317.76C192.606 317.674 192.584 317.597 192.553 317.528C192.523 317.459 192.481 317.401 192.429 317.352C192.377 317.304 192.315 317.267 192.242 317.241C192.169 317.215 192.084 317.202 191.988 317.202C191.823 317.202 191.665 317.244 191.515 317.328C191.365 317.412 191.236 317.536 191.128 317.699C191.02 317.861 190.947 318.059 190.908 318.294C190.868 318.53 190.871 318.729 190.917 318.892C190.962 319.055 191.042 319.179 191.158 319.263C191.274 319.347 191.417 319.389 191.587 319.389C191.745 319.389 191.89 319.357 192.023 319.293C192.156 319.228 192.266 319.137 192.354 319.02C192.443 318.902 192.5 318.762 192.526 318.602L192.635 318.624H191.803L191.865 318.261H193.01L192.952 318.592C192.913 318.838 192.827 319.05 192.694 319.23C192.56 319.409 192.394 319.547 192.195 319.645C191.997 319.741 191.78 319.79 191.544 319.79C191.281 319.79 191.06 319.729 190.882 319.608C190.704 319.487 190.578 319.315 190.505 319.092C190.432 318.869 190.421 318.604 190.472 318.297C190.509 318.065 190.575 317.857 190.669 317.672C190.765 317.487 190.882 317.33 191.02 317.202C191.158 317.072 191.312 316.973 191.482 316.905C191.652 316.836 191.831 316.801 192.019 316.801C192.176 316.801 192.319 316.824 192.446 316.871C192.575 316.917 192.686 316.983 192.779 317.068C192.872 317.153 192.943 317.255 192.993 317.372C193.043 317.489 193.069 317.618 193.069 317.76H192.618ZM167.374 323.75L167.857 320.841H168.894C169.119 320.841 169.299 320.882 169.434 320.964C169.569 321.047 169.662 321.159 169.712 321.301C169.763 321.443 169.774 321.604 169.745 321.783C169.715 321.962 169.65 322.123 169.552 322.266C169.454 322.408 169.324 322.52 169.161 322.604C168.998 322.686 168.804 322.727 168.58 322.727H167.866L167.927 322.355H168.6C168.743 322.355 168.863 322.33 168.961 322.281C169.059 322.231 169.136 322.163 169.192 322.077C169.248 321.99 169.285 321.892 169.302 321.783C169.32 321.672 169.315 321.574 169.287 321.49C169.26 321.405 169.206 321.338 169.124 321.29C169.044 321.241 168.931 321.217 168.786 321.217H168.235L167.813 323.75H167.374ZM169.925 323.75L170.408 320.841H170.847L170.426 323.372H171.744L171.682 323.75H169.925ZM172.577 323.75H172.111L173.641 320.841H174.148L174.712 323.75H174.246L173.821 321.369H173.798L172.577 323.75ZM172.844 322.611H174.355L174.293 322.98H172.781L172.844 322.611ZM175.065 321.219L175.128 320.841H177.379L177.317 321.219H176.409L175.988 323.75H175.551L175.971 321.219H175.065ZM177.394 323.75L177.877 320.841H179.681L179.618 321.219H178.253L178.105 322.105H179.341L179.279 322.482H178.043L177.833 323.75H177.394ZM182.502 322.324C182.45 322.63 182.351 322.892 182.203 323.111C182.057 323.33 181.877 323.498 181.664 323.615C181.451 323.732 181.222 323.79 180.976 323.79C180.719 323.79 180.5 323.729 180.318 323.607C180.137 323.483 180.008 323.309 179.929 323.082C179.851 322.855 179.837 322.584 179.889 322.27C179.941 321.964 180.039 321.702 180.186 321.483C180.334 321.263 180.514 321.095 180.727 320.977C180.941 320.86 181.173 320.801 181.421 320.801C181.675 320.801 181.893 320.863 182.073 320.986C182.253 321.108 182.383 321.283 182.462 321.511C182.54 321.739 182.554 322.009 182.502 322.324ZM182.074 322.27C182.113 322.038 182.108 321.843 182.06 321.685C182.012 321.526 181.932 321.405 181.817 321.324C181.702 321.242 181.564 321.202 181.402 321.202C181.23 321.202 181.068 321.245 180.918 321.332C180.768 321.42 180.64 321.546 180.534 321.713C180.428 321.88 180.356 322.083 180.317 322.324C180.277 322.556 180.281 322.751 180.33 322.909C180.378 323.067 180.459 323.187 180.574 323.268C180.69 323.349 180.828 323.389 180.99 323.389C181.162 323.389 181.322 323.346 181.472 323.26C181.622 323.173 181.751 323.046 181.857 322.881C181.963 322.714 182.035 322.51 182.074 322.27ZM182.812 323.75L183.295 320.841H184.331C184.557 320.841 184.737 320.88 184.873 320.957C185.009 321.034 185.103 321.141 185.154 321.278C185.206 321.415 185.217 321.573 185.188 321.753C185.158 321.931 185.094 322.087 184.996 322.222C184.9 322.356 184.77 322.461 184.608 322.537C184.447 322.612 184.254 322.649 184.029 322.649H183.243L183.309 322.271H184.054C184.197 322.271 184.317 322.251 184.412 322.21C184.508 322.17 184.583 322.11 184.637 322.033C184.692 321.955 184.728 321.862 184.745 321.753C184.763 321.642 184.758 321.547 184.729 321.467C184.701 321.387 184.645 321.325 184.563 321.283C184.481 321.239 184.367 321.217 184.224 321.217H183.672L183.251 323.75H182.812ZM184.465 322.438L184.966 323.75H184.466L183.978 322.438H184.465ZM185.884 320.841H186.417L186.971 323.102H187.005L188.303 320.841H188.836L188.353 323.75H187.936L188.286 321.645H188.259L187.052 323.746H186.704L186.198 321.643H186.171L185.819 323.75H185.401L185.884 320.841ZM173.688 327.75L173.743 327.432L174.894 326.412C175.017 326.301 175.12 326.204 175.202 326.121C175.285 326.036 175.35 325.956 175.397 325.881C175.444 325.805 175.475 325.724 175.49 325.639C175.506 325.543 175.498 325.459 175.465 325.389C175.433 325.318 175.381 325.264 175.31 325.226C175.239 325.187 175.154 325.168 175.054 325.168C174.95 325.168 174.855 325.189 174.77 325.232C174.685 325.274 174.614 325.334 174.557 325.412C174.5 325.49 174.463 325.58 174.445 325.685H174.027C174.057 325.508 174.124 325.353 174.229 325.22C174.334 325.088 174.464 324.985 174.62 324.912C174.775 324.838 174.943 324.801 175.124 324.801C175.308 324.801 175.462 324.838 175.588 324.911C175.715 324.982 175.807 325.081 175.864 325.206C175.921 325.33 175.936 325.47 175.909 325.626C175.89 325.735 175.852 325.841 175.794 325.945C175.737 326.047 175.648 326.161 175.527 326.288C175.407 326.414 175.243 326.567 175.036 326.747L174.36 327.352L174.355 327.374H175.664L175.603 327.75H173.688ZM177.147 327.798C176.922 327.798 176.74 327.74 176.601 327.622C176.462 327.504 176.369 327.332 176.323 327.108C176.276 326.884 176.279 326.613 176.33 326.297C176.382 325.982 176.469 325.712 176.59 325.489C176.712 325.265 176.862 325.095 177.04 324.977C177.219 324.86 177.42 324.801 177.642 324.801C177.864 324.801 178.045 324.86 178.185 324.979C178.325 325.096 178.419 325.266 178.468 325.489C178.517 325.711 178.515 325.981 178.462 326.297C178.409 326.614 178.322 326.884 178.201 327.108C178.079 327.331 177.929 327.502 177.75 327.621C177.571 327.739 177.37 327.798 177.147 327.798ZM177.209 327.419C177.407 327.419 177.578 327.323 177.721 327.131C177.864 326.938 177.965 326.661 178.026 326.297C178.066 326.055 178.074 325.851 178.05 325.685C178.027 325.517 177.976 325.39 177.895 325.304C177.816 325.217 177.711 325.173 177.58 325.173C177.385 325.173 177.215 325.27 177.071 325.464C176.928 325.658 176.827 325.935 176.767 326.297C176.727 326.539 176.718 326.744 176.74 326.912C176.763 327.079 176.814 327.205 176.894 327.291C176.973 327.376 177.078 327.419 177.209 327.419ZM178.723 327.75L178.778 327.432L179.929 326.412C180.052 326.301 180.155 326.204 180.237 326.121C180.321 326.036 180.385 325.956 180.432 325.881C180.479 325.805 180.51 325.724 180.526 325.639C180.542 325.543 180.533 325.459 180.5 325.389C180.468 325.318 180.416 325.264 180.345 325.226C180.274 325.187 180.189 325.168 180.089 325.168C179.985 325.168 179.891 325.189 179.805 325.232C179.72 325.274 179.649 325.334 179.592 325.412C179.535 325.49 179.498 325.58 179.48 325.685H179.062C179.092 325.508 179.159 325.353 179.264 325.22C179.369 325.088 179.5 324.985 179.655 324.912C179.81 324.838 179.978 324.801 180.159 324.801C180.343 324.801 180.498 324.838 180.624 324.911C180.75 324.982 180.842 325.081 180.899 325.206C180.956 325.33 180.971 325.47 180.945 325.626C180.926 325.735 180.887 325.841 180.83 325.945C180.772 326.047 180.683 326.161 180.562 326.288C180.442 326.414 180.278 326.567 180.071 326.747L179.395 327.352L179.391 327.374H180.699L180.638 327.75H178.723ZM182.131 327.79C181.953 327.79 181.798 327.755 181.668 327.686C181.537 327.617 181.439 327.522 181.375 327.402C181.311 327.282 181.288 327.145 181.308 326.991H181.734C181.725 327.116 181.764 327.218 181.851 327.3C181.938 327.38 182.051 327.42 182.19 327.42C182.302 327.42 182.406 327.395 182.501 327.344C182.597 327.292 182.677 327.221 182.741 327.131C182.807 327.04 182.849 326.936 182.869 326.818C182.888 326.7 182.88 326.594 182.844 326.501C182.808 326.409 182.75 326.336 182.669 326.283C182.589 326.229 182.49 326.202 182.374 326.202C182.286 326.202 182.196 326.217 182.102 326.249C182.009 326.279 181.929 326.318 181.865 326.366L181.473 326.307L181.881 324.841H183.48L183.419 325.217H182.185L181.956 326.031H181.973C182.04 325.975 182.124 325.929 182.223 325.893C182.322 325.857 182.427 325.838 182.535 325.838C182.713 325.838 182.864 325.88 182.989 325.964C183.114 326.049 183.204 326.164 183.259 326.31C183.314 326.455 183.326 326.622 183.294 326.81C183.264 326.998 183.194 327.166 183.084 327.314C182.974 327.462 182.837 327.578 182.672 327.663C182.507 327.748 182.327 327.79 182.131 327.79Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 331,
    width: 10,
    height: 11
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 331.199H205.299V341.724H196.633V331.199Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 331,
    width: 10,
    height: 11
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M198.991 340.015C199.451 338.147 200.229 333.518 197.357 331.285C197.357 331.285 195.16 338.226 198.68 340.76C201.97 343.833 205.261 337.792 205.261 337.792C202.471 335.366 199.94 338.551 198.991 340.015Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.272 331.285V343.833H195.172V331.285H205.272Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 335,
    width: 10,
    height: 12
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M193.75 335.051H202.039V346.452H193.75V335.051Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 335,
    width: 9,
    height: 12
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M195.524 344.226C196.242 342.525 197.671 338.201 195.177 335.211C195.177 335.211 192.028 341.396 195.111 344.862C197.894 348.796 201.986 343.796 201.986 343.796C199.602 340.635 196.664 343.057 195.524 344.226Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.012 335.211V348.796H192.055V335.211H202.012Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 327,
    width: 9,
    height: 10
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M198.773 327.336H206.937V336.106H198.773V327.336Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 327,
    width: 9,
    height: 10
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M201.539 334.926C201.741 333.152 201.919 328.819 199.09 327.445C199.09 327.445 197.899 334.157 201.343 335.659C204.642 337.689 206.915 331.554 206.915 331.554C204.138 329.985 202.226 333.405 201.539 334.926Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.907 327.445V337.689H197.891V327.445H206.907Z",
    fill: "#9C9C9C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 323,
    width: 9,
    height: 8
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M200.148 323.309H208.186V330.851H200.148V323.309Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 323,
    width: 9,
    height: 8
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M203.473 329.89C203.453 328.159 203.104 324.013 200.258 323.367C200.258 323.367 199.93 330.006 203.373 330.629C206.743 331.794 208.164 325.442 208.164 325.442C205.345 324.592 203.941 328.278 203.473 329.89Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.149 323.367V331.794H199.914V323.367H208.149Z",
    fill: "#969696"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 318,
    width: 9,
    height: 8
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M200.922 318.566H208.582V325.407H200.922V318.566Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 318,
    width: 8,
    height: 8
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M204.378 324.594C204.278 322.958 203.749 319.062 201.023 318.707C201.023 318.707 201.023 325.025 204.318 325.297C207.566 326.096 208.611 319.943 208.611 319.943C205.901 319.413 204.746 323.035 204.378 324.594Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.611 318.707V326.096H201.023V318.707H208.611Z",
    fill: "#B0B0B0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 313,
    width: 8,
    height: 7
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M200.922 313.996H207.578V319.785H200.922V313.996Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 314,
    width: 7,
    height: 6
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M204.584 319.008C204.293 317.666 203.346 314.541 201.023 314.935C201.023 314.935 201.841 320.214 204.626 319.617C207.442 319.463 207.524 314.062 207.524 314.062C205.189 314.294 204.69 317.611 204.584 319.008Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.524 314.062V320.214H201.023V314.062H207.524Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 309,
    width: 7,
    height: 7
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M200.672 309.441H206.449V315.23H200.672V309.441Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 309,
    width: 7,
    height: 7
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M204.217 314.406C203.845 313.261 202.756 310.636 200.727 311.361C200.727 311.361 201.881 315.921 204.306 314.948C206.795 314.368 206.428 309.559 206.428 309.559C204.372 310.127 204.199 313.15 204.217 314.406Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.795 309.559V315.921H200.727V309.559H206.795Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 305,
    width: 5,
    height: 7
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M200.258 305.938H204.905V311.2H200.258V305.938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 306,
    width: 5,
    height: 6
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M203.394 310.411C202.992 309.547 201.88 307.61 200.297 308.538C200.297 308.538 201.634 312.032 203.512 310.828C205.475 309.932 204.757 306.102 204.757 306.102C203.144 306.92 203.269 309.397 203.394 310.411Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.475 306.102V312.032H200.297V306.102H205.475Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 302,
    width: 5,
    height: 6
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M199.406 302.781H203.802V307.868H199.406V302.781Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 302,
    width: 5,
    height: 6
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M202.462 307.114C202.026 306.369 200.827 304.729 199.422 305.837C199.422 305.837 200.945 308.896 202.605 307.485C204.368 306.347 203.396 302.879 203.396 302.879C201.957 303.89 202.27 306.186 202.462 307.114Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.368 302.879V308.896H199.422V302.879H204.368Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 299,
    width: 5,
    height: 7
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M198.25 299.977H202.269V305.063H198.25V299.977Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 300,
    width: 5,
    height: 6
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M201.295 304.19C200.827 303.557 199.593 302.191 198.359 303.427C198.359 303.427 200.005 306.066 201.455 304.517C203.022 303.204 201.861 300.098 201.861 300.098C200.585 301.247 201.043 303.35 201.295 304.19Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.022 300.098V306.066H198.359V300.098H203.022Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 298,
    width: 4,
    height: 5
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M197.641 298.395H200.78V302.604H197.641V298.395Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 298,
    width: 4,
    height: 5
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M200.031 301.747C199.617 301.34 198.554 300.469 197.703 301.619C197.703 301.619 199.187 303.403 200.176 301.974C201.28 300.713 200.132 298.496 200.132 298.496C199.243 299.585 199.767 301.138 200.031 301.747Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.28 298.496V303.403H197.703V298.496H201.28Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 296,
    width: 4,
    height: 5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M196.008 296.992H199.399V300.5H196.008V296.992Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 297,
    width: 4,
    height: 4
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M199.283 300.464C199.283 300.464 197.482 301.036 196.102 297.03C196.102 297.03 198.461 296.44 199.283 300.464Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.283 296.438V301.034H196.102V296.438H199.283Z",
    fill: "#D6D6D6"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 331,
    width: 9,
    height: 11
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M160.938 331.199H152.272V341.724H160.938V331.199Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 331,
    width: 9,
    height: 11
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M158.587 340.015C158.127 338.147 157.349 333.518 160.222 331.285C160.222 331.285 162.418 338.226 158.898 340.76C155.608 343.833 152.317 337.792 152.317 337.792C155.108 335.366 157.639 338.551 158.587 340.015Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.306 331.285V343.833H162.406V331.285H152.306Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 335,
    width: 9,
    height: 12
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M163.828 335.051H155.539V346.452H163.828V335.051Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask77_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 335,
    width: 9,
    height: 12
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M162.069 344.226C161.352 342.525 159.922 338.201 162.417 335.211C162.417 335.211 165.566 341.396 162.482 344.862C159.7 348.796 155.608 343.796 155.608 343.796C157.992 340.635 160.93 343.057 162.069 344.226Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.589 335.211V348.796H165.547V335.211H155.589Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 327,
    width: 9,
    height: 10
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M158.789 327.336H150.626V336.106H158.789V327.336Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask79_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 327,
    width: 9,
    height: 10
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M156.015 334.926C155.813 333.152 155.636 328.819 158.465 327.445C158.465 327.445 159.656 334.157 156.212 335.659C152.913 337.689 150.639 331.554 150.639 331.554C153.416 329.985 155.329 333.405 156.015 334.926Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.647 327.445V337.689H159.664V327.445H150.647Z",
    fill: "#9C9C9C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 323,
    width: 9,
    height: 8
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M157.43 323.309H149.392V330.851H157.43V323.309Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask81_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 323,
    width: 9,
    height: 8
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M154.113 329.89C154.133 328.159 154.482 324.013 157.327 323.367C157.327 323.367 157.656 330.006 154.213 330.629C150.843 331.794 149.421 325.442 149.421 325.442C152.24 324.592 153.645 328.278 154.113 329.89Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.437 323.367V331.794H157.672V323.367H149.437Z",
    fill: "#969696"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 318,
    width: 8,
    height: 8
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M156.664 318.566H149.004V325.407H156.664V318.566Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask83_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 318,
    width: 8,
    height: 8
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M153.24 324.594C153.34 322.958 153.868 319.062 156.594 318.707C156.594 318.707 156.594 325.025 153.299 325.297C150.051 326.096 149.007 319.943 149.007 319.943C151.716 319.413 152.872 323.035 153.24 324.594Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.007 318.707V326.096H156.594V318.707H149.007Z",
    fill: "#B0B0B0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 313,
    width: 7,
    height: 7
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M156.664 313.996H150.008V319.785H156.664V313.996Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask85_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 314,
    width: 7,
    height: 6
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M153.033 319.008C153.324 317.666 154.271 314.541 156.594 314.935C156.594 314.935 155.776 320.214 152.991 319.617C150.175 319.463 150.093 314.062 150.093 314.062C152.428 314.294 152.927 317.611 153.033 319.008Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.093 314.062V320.214H156.594V314.062H150.093Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 309,
    width: 6,
    height: 7
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M156.914 309.441H151.137V315.23H156.914V309.441Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask87_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 309,
    width: 6,
    height: 7
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M153.369 314.406C153.741 313.261 154.83 310.636 156.859 311.361C156.859 311.361 155.705 315.921 153.28 314.948C150.791 314.368 151.158 309.559 151.158 309.559C153.214 310.127 153.387 313.15 153.369 314.406Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.791 309.559V315.921H156.859V309.559H150.791Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 305,
    width: 6,
    height: 7
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M157.32 305.938H152.673V311.2H157.32V305.938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask89_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 306,
    width: 6,
    height: 6
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M154.184 310.411C154.586 309.547 155.699 307.61 157.281 308.538C157.281 308.538 155.944 312.032 154.066 310.828C152.103 309.932 152.821 306.102 152.821 306.102C154.434 306.92 154.309 309.397 154.184 310.411Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.103 306.102V312.032H157.281V306.102H152.103Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 302,
    width: 6,
    height: 6
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M158.18 302.781H153.784V307.868H158.18V302.781Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask91_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 302,
    width: 6,
    height: 6
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M155.108 307.114C155.544 306.369 156.743 304.729 158.148 305.837C158.148 305.837 156.625 308.896 154.965 307.485C153.203 306.347 154.174 302.879 154.174 302.879C155.613 303.89 155.3 306.186 155.108 307.114Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.203 302.879V308.896H158.148V302.879H153.203Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 299,
    width: 5,
    height: 7
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M159.336 299.977H155.317V305.063H159.336V299.977Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask93_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 300,
    width: 5,
    height: 6
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M156.307 304.19C156.775 303.557 158.009 302.191 159.242 303.427C159.242 303.427 157.597 306.066 156.147 304.517C154.58 303.204 155.741 300.098 155.741 300.098C157.016 301.247 156.559 303.35 156.307 304.19Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.58 300.098V306.066H159.242V300.098H154.58Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 298,
    width: 4,
    height: 5
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M159.945 298.395H156.805V302.604H159.945V298.395Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask95_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 298,
    width: 4,
    height: 5
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M157.54 301.747C157.953 301.34 159.016 300.469 159.867 301.619C159.867 301.619 158.384 303.403 157.395 301.974C156.291 300.713 157.438 298.496 157.438 298.496C158.327 299.585 157.803 301.138 157.54 301.747Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.291 298.496V303.403H159.867V298.496H156.291Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 296,
    width: 4,
    height: 5
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M161.594 296.992H158.203V300.5H161.594V296.992Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_1660_11690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask97_1660_11690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 297,
    width: 4,
    height: 4
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M158.28 300.464C158.28 300.464 160.081 301.036 161.461 297.03C161.461 297.03 159.102 296.44 158.28 300.464Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_1660_11690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.28 296.438V301.034H161.461V296.438H158.28Z",
    fill: "#D6D6D6"
  })))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M159.679 309.506L159.806 308.746H163.39L163.262 309.506H161.926L161.33 313.109H160.418L161.014 309.506H159.679ZM163.256 313.109L163.98 308.746H164.903L164.605 310.546H166.478L166.776 308.746H167.696L166.972 313.109H166.051L166.35 311.307H164.477L164.179 313.109H163.256ZM167.733 313.109L168.457 308.746H171.397L171.269 309.506H169.252L169.081 310.546H170.948L170.82 311.307H168.953L168.783 312.349H170.809L170.681 313.109H167.733ZM175.723 310.273H174.803C174.805 310.151 174.79 310.043 174.756 309.95C174.722 309.854 174.671 309.773 174.602 309.707C174.536 309.64 174.454 309.589 174.357 309.555C174.261 309.52 174.152 309.502 174.031 309.502C173.798 309.502 173.585 309.56 173.39 309.677C173.195 309.793 173.031 309.962 172.898 310.184C172.764 310.404 172.672 310.67 172.621 310.983C172.571 311.284 172.574 311.536 172.629 311.739C172.685 311.942 172.783 312.096 172.923 312.2C173.065 312.302 173.242 312.353 173.454 312.353C173.585 312.353 173.709 312.337 173.827 312.304C173.945 312.27 174.052 312.222 174.149 312.159C174.247 312.095 174.332 312.018 174.404 311.927C174.478 311.836 174.536 311.733 174.577 311.618H175.504C175.445 311.818 175.354 312.011 175.231 312.197C175.109 312.384 174.957 312.55 174.777 312.696C174.597 312.841 174.391 312.956 174.161 313.041C173.931 313.126 173.679 313.169 173.405 313.169C173.009 313.169 172.668 313.078 172.384 312.896C172.102 312.714 171.898 312.452 171.773 312.11C171.648 311.768 171.624 311.355 171.703 310.872C171.781 310.405 171.933 310.009 172.161 309.683C172.389 309.357 172.667 309.109 172.994 308.94C173.322 308.771 173.673 308.686 174.046 308.686C174.306 308.686 174.541 308.722 174.752 308.793C174.962 308.864 175.141 308.967 175.288 309.104C175.438 309.239 175.55 309.404 175.625 309.6C175.7 309.796 175.733 310.021 175.723 310.273ZM180.282 310.987C180.202 311.453 180.048 311.849 179.819 312.174C179.592 312.499 179.314 312.746 178.986 312.915C178.66 313.085 178.307 313.169 177.929 313.169C177.533 313.169 177.191 313.079 176.905 312.898C176.619 312.718 176.412 312.457 176.285 312.116C176.157 311.774 176.133 311.362 176.212 310.879C176.289 310.411 176.441 310.015 176.67 309.69C176.899 309.363 177.178 309.114 177.508 308.944C177.837 308.772 178.191 308.686 178.571 308.686C178.964 308.686 179.304 308.777 179.589 308.959C179.876 309.141 180.083 309.403 180.209 309.747C180.337 310.089 180.361 310.503 180.282 310.987ZM179.363 310.879C179.413 310.579 179.411 310.327 179.357 310.124C179.304 309.92 179.208 309.765 179.067 309.66C178.927 309.555 178.749 309.502 178.535 309.502C178.302 309.502 178.088 309.56 177.893 309.677C177.7 309.793 177.537 309.962 177.403 310.184C177.271 310.404 177.179 310.672 177.128 310.987C177.077 311.288 177.079 311.54 177.133 311.741C177.188 311.943 177.287 312.096 177.429 312.2C177.572 312.302 177.75 312.353 177.964 312.353C178.195 312.353 178.407 312.296 178.598 312.183C178.792 312.067 178.954 311.901 179.086 311.682C179.218 311.462 179.311 311.194 179.363 310.879ZM182.258 308.746L181.534 313.109H180.611L181.336 308.746H182.258ZM186.667 308.746L185.943 313.109H185.146L183.708 310.363H183.674L183.216 313.109H182.293L183.017 308.746H183.827L185.259 311.49H185.295L185.749 308.746H186.667ZM186.705 313.109L187.43 308.746H189.151C189.481 308.746 189.752 308.804 189.965 308.92C190.18 309.037 190.33 309.202 190.417 309.417C190.505 309.63 190.525 309.881 190.479 310.171C190.43 310.461 190.326 310.71 190.165 310.917C190.006 311.124 189.799 311.284 189.543 311.396C189.289 311.507 188.994 311.562 188.659 311.562H187.506L187.634 310.821H188.636C188.812 310.821 188.962 310.797 189.087 310.749C189.212 310.7 189.311 310.628 189.383 310.531C189.457 310.435 189.506 310.315 189.528 310.171C189.552 310.025 189.544 309.903 189.503 309.805C189.462 309.705 189.387 309.63 189.279 309.579C189.171 309.526 189.029 309.5 188.853 309.5H188.231L187.628 313.109H186.705ZM189.39 311.124L190.146 313.109H189.128L188.395 311.124H189.39ZM192.325 308.746L191.6 313.109H190.678L191.402 308.746H192.325ZM195.238 310.013C195.245 309.836 195.193 309.699 195.082 309.602C194.973 309.506 194.808 309.457 194.586 309.457C194.435 309.457 194.305 309.479 194.194 309.521C194.083 309.562 193.994 309.62 193.928 309.694C193.862 309.766 193.822 309.85 193.806 309.945C193.791 310.023 193.796 310.092 193.821 310.15C193.848 310.208 193.89 310.259 193.947 310.301C194.005 310.342 194.074 310.379 194.153 310.41C194.233 310.44 194.318 310.465 194.407 310.487L194.782 310.58C194.965 310.623 195.13 310.68 195.276 310.751C195.424 310.822 195.548 310.909 195.647 311.013C195.748 311.116 195.819 311.239 195.86 311.379C195.901 311.52 195.907 311.681 195.877 311.863C195.832 312.13 195.726 312.362 195.56 312.558C195.394 312.752 195.176 312.903 194.906 313.011C194.636 313.118 194.323 313.171 193.968 313.171C193.616 313.171 193.318 313.117 193.075 313.009C192.832 312.901 192.656 312.741 192.545 312.53C192.435 312.317 192.403 312.053 192.447 311.739H193.34C193.324 311.886 193.345 312.008 193.403 312.106C193.463 312.202 193.552 312.276 193.67 312.325C193.788 312.374 193.926 312.398 194.085 312.398C194.243 312.398 194.383 312.375 194.505 312.33C194.629 312.284 194.729 312.221 194.805 312.14C194.882 312.059 194.929 311.966 194.946 311.861C194.963 311.763 194.948 311.68 194.901 311.614C194.854 311.547 194.779 311.49 194.676 311.443C194.573 311.395 194.446 311.352 194.294 311.315L193.838 311.196C193.486 311.107 193.22 310.967 193.039 310.776C192.859 310.586 192.794 310.33 192.845 310.007C192.891 309.743 193.001 309.512 193.176 309.315C193.352 309.116 193.573 308.962 193.84 308.852C194.109 308.741 194.402 308.686 194.72 308.686C195.044 308.686 195.318 308.742 195.541 308.854C195.764 308.965 195.926 309.12 196.028 309.319C196.131 309.518 196.162 309.749 196.122 310.013H195.238ZM196.291 313.109L197.016 308.746H199.956L199.828 309.506H197.81L197.64 310.546H199.506L199.378 311.307H197.512L197.342 312.349H199.368L199.24 313.109H196.291Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M158.356 431.352L159.081 426.984H160.83C161.151 426.984 161.411 427.031 161.611 427.127C161.811 427.222 161.951 427.354 162.031 427.523C162.11 427.691 162.132 427.884 162.095 428.103C162.065 428.274 162.004 428.423 161.913 428.551C161.824 428.679 161.713 428.784 161.581 428.867C161.448 428.949 161.305 429.008 161.15 429.042L161.141 429.084C161.306 429.092 161.455 429.138 161.587 429.225C161.719 429.311 161.818 429.431 161.884 429.588C161.949 429.744 161.964 429.93 161.928 430.144C161.89 430.376 161.798 430.583 161.653 430.765C161.508 430.946 161.315 431.089 161.073 431.194C160.833 431.299 160.549 431.352 160.222 431.352H158.356ZM159.407 430.597H160.16C160.416 430.597 160.612 430.547 160.747 430.447C160.882 430.348 160.963 430.216 160.99 430.053C161.008 429.932 160.996 429.825 160.954 429.733C160.912 429.64 160.842 429.568 160.742 429.515C160.644 429.463 160.52 429.436 160.369 429.436H159.597L159.407 430.597ZM159.704 428.811H160.388C160.514 428.811 160.629 428.789 160.736 428.745C160.844 428.7 160.933 428.636 161.003 428.553C161.074 428.469 161.119 428.371 161.137 428.257C161.163 428.098 161.127 427.97 161.03 427.875C160.935 427.778 160.786 427.73 160.583 427.73H159.883L159.704 428.811ZM163.943 426.984L163.218 431.352H162.31L163.035 426.984H163.943ZM165.43 431.416C165.096 431.416 164.82 431.344 164.601 431.202C164.382 431.059 164.227 430.86 164.138 430.605C164.05 430.349 164.033 430.051 164.089 429.711C164.143 429.376 164.255 429.082 164.426 428.831C164.596 428.579 164.813 428.383 165.076 428.244C165.339 428.103 165.636 428.033 165.966 428.033C166.298 428.033 166.574 428.105 166.793 428.248C167.012 428.391 167.166 428.59 167.256 428.846C167.346 429.101 167.363 429.399 167.307 429.739C167.252 430.073 167.138 430.366 166.966 430.618C166.794 430.87 166.577 431.066 166.315 431.207C166.054 431.346 165.759 431.416 165.43 431.416ZM165.52 430.712C165.673 430.712 165.809 430.668 165.927 430.582C166.047 430.493 166.145 430.374 166.224 430.223C166.303 430.071 166.359 429.899 166.39 429.707C166.421 429.518 166.423 429.35 166.396 429.204C166.369 429.056 166.313 428.939 166.226 428.854C166.141 428.769 166.023 428.726 165.874 428.726C165.72 428.726 165.584 428.77 165.464 428.858C165.345 428.945 165.246 429.065 165.168 429.217C165.09 429.369 165.035 429.542 165.004 429.735C164.974 429.923 164.972 430.09 164.997 430.238C165.023 430.385 165.079 430.501 165.166 430.586C165.253 430.67 165.371 430.712 165.52 430.712ZM169.101 431.416C168.764 431.416 168.487 431.344 168.269 431.202C168.053 431.059 167.901 430.86 167.815 430.605C167.729 430.351 167.714 430.058 167.77 429.726C167.824 429.391 167.937 429.097 168.109 428.843C168.281 428.589 168.499 428.391 168.764 428.248C169.03 428.105 169.328 428.033 169.66 428.033C169.945 428.033 170.187 428.085 170.385 428.189C170.582 428.292 170.727 428.438 170.82 428.626C170.912 428.814 170.943 429.034 170.914 429.287H170.058C170.06 429.125 170.018 428.993 169.933 428.892C169.847 428.792 169.722 428.741 169.557 428.741C169.415 428.741 169.284 428.779 169.165 428.856C169.047 428.932 168.947 429.042 168.864 429.187C168.783 429.332 168.726 429.507 168.693 429.714C168.659 429.923 168.659 430.1 168.691 430.247C168.724 430.393 168.787 430.505 168.879 430.582C168.971 430.658 169.088 430.697 169.229 430.697C169.334 430.697 169.431 430.675 169.521 430.633C169.612 430.59 169.692 430.528 169.76 430.447C169.828 430.365 169.881 430.266 169.918 430.151H170.775C170.717 430.402 170.611 430.623 170.457 430.812C170.305 431.001 170.114 431.149 169.884 431.256C169.653 431.362 169.392 431.416 169.101 431.416ZM172.133 430.409L172.314 429.319H172.447L173.707 428.076H174.75L173.069 429.722H172.852L172.133 430.409ZM171.154 431.352L171.879 426.984H172.788L172.063 431.352H171.154ZM173.202 431.352L172.476 429.925L173.187 429.283L174.266 431.352H173.202ZM175.986 431.416C175.649 431.416 175.372 431.344 175.155 431.202C174.939 431.059 174.787 430.86 174.7 430.605C174.615 430.351 174.6 430.058 174.656 429.726C174.71 429.391 174.823 429.097 174.995 428.843C175.167 428.589 175.385 428.391 175.649 428.248C175.915 428.105 176.214 428.033 176.545 428.033C176.831 428.033 177.073 428.085 177.27 428.189C177.468 428.292 177.613 428.438 177.705 428.626C177.798 428.814 177.829 429.034 177.799 429.287H176.944C176.945 429.125 176.903 428.993 176.818 428.892C176.733 428.792 176.608 428.741 176.443 428.741C176.301 428.741 176.17 428.779 176.05 428.856C175.932 428.932 175.832 429.042 175.75 429.187C175.669 429.332 175.612 429.507 175.579 429.714C175.545 429.923 175.544 430.1 175.577 430.247C175.61 430.393 175.672 430.505 175.765 430.582C175.857 430.658 175.974 430.697 176.114 430.697C176.22 430.697 176.317 430.675 176.407 430.633C176.498 430.59 176.577 430.528 176.645 430.447C176.714 430.365 176.766 430.266 176.803 430.151H177.661C177.602 430.402 177.496 430.623 177.343 430.812C177.191 431.001 176.999 431.149 176.769 431.256C176.539 431.362 176.278 431.416 175.986 431.416ZM179.268 429.458L178.953 431.352H178.046L178.771 426.984H179.652L179.379 428.654H179.415C179.521 428.46 179.665 428.309 179.848 428.199C180.032 428.088 180.249 428.033 180.499 428.033C180.726 428.033 180.916 428.083 181.068 428.182C181.222 428.28 181.331 428.422 181.395 428.607C181.459 428.79 181.469 429.01 181.427 429.266L181.077 431.352H180.17L180.49 429.428C180.523 429.226 180.497 429.069 180.411 428.956C180.327 428.844 180.194 428.788 180.01 428.788C179.887 428.788 179.773 428.814 179.669 428.867C179.565 428.92 179.478 428.996 179.407 429.097C179.337 429.197 179.291 429.317 179.268 429.458ZM182.713 431.413C182.506 431.413 182.326 431.377 182.174 431.305C182.023 431.231 181.912 431.121 181.841 430.976C181.77 430.831 181.752 430.651 181.788 430.437C181.819 430.255 181.878 430.102 181.965 429.98C182.053 429.856 182.16 429.757 182.287 429.682C182.413 429.606 182.553 429.549 182.707 429.509C182.862 429.469 183.022 429.442 183.187 429.428C183.377 429.408 183.532 429.389 183.652 429.37C183.772 429.352 183.863 429.325 183.922 429.291C183.982 429.256 184.018 429.203 184.031 429.133V429.121C184.053 428.987 184.028 428.883 183.957 428.809C183.887 428.734 183.775 428.696 183.622 428.696C183.46 428.696 183.322 428.732 183.208 428.803C183.096 428.874 183.015 428.964 182.967 429.074L182.139 429.006C182.213 428.806 182.325 428.634 182.474 428.489C182.625 428.343 182.806 428.231 183.018 428.152C183.23 428.073 183.467 428.033 183.73 428.033C183.912 428.033 184.082 428.054 184.24 428.097C184.399 428.14 184.537 428.206 184.652 428.295C184.768 428.385 184.852 428.5 184.903 428.641C184.956 428.78 184.967 428.947 184.935 429.142L184.567 431.352H183.705L183.782 430.897H183.756C183.686 431 183.601 431.09 183.5 431.168C183.399 431.245 183.283 431.305 183.152 431.349C183.022 431.392 182.875 431.413 182.713 431.413ZM183.078 430.786C183.21 430.786 183.332 430.76 183.443 430.707C183.555 430.653 183.647 430.581 183.72 430.49C183.794 430.399 183.841 430.296 183.861 430.181L183.916 429.833C183.888 429.852 183.846 429.868 183.792 429.882C183.74 429.896 183.682 429.91 183.62 429.923C183.558 429.934 183.497 429.945 183.434 429.955C183.371 429.963 183.315 429.972 183.266 429.98C183.156 429.996 183.058 430.021 182.971 430.055C182.884 430.089 182.814 430.135 182.76 430.193C182.706 430.25 182.673 430.321 182.66 430.407C182.64 430.53 182.669 430.625 182.747 430.69C182.827 430.754 182.937 430.786 183.078 430.786ZM185.271 431.352L185.817 428.076H186.726L186.18 431.352H185.271ZM186.365 427.649C186.23 427.649 186.119 427.604 186.031 427.515C185.944 427.424 185.908 427.316 185.924 427.191C185.94 427.063 186.001 426.955 186.107 426.866C186.214 426.777 186.335 426.732 186.47 426.732C186.605 426.732 186.715 426.777 186.801 426.866C186.886 426.955 186.921 427.063 186.907 427.191C186.893 427.316 186.833 427.424 186.726 427.515C186.621 427.604 186.501 427.649 186.365 427.649ZM188.136 429.458L187.821 431.352H186.914L187.46 428.076H188.324L188.23 428.654H188.266C188.37 428.462 188.517 428.31 188.706 428.199C188.896 428.088 189.113 428.033 189.356 428.033C189.584 428.033 189.773 428.083 189.926 428.182C190.079 428.282 190.187 428.423 190.25 428.607C190.314 428.79 190.324 429.01 190.282 429.266L189.932 431.352H189.023L189.345 429.428C189.378 429.227 189.353 429.071 189.269 428.959C189.186 428.845 189.053 428.788 188.87 428.788C188.748 428.788 188.635 428.814 188.533 428.867C188.431 428.92 188.345 428.996 188.275 429.097C188.207 429.197 188.16 429.317 188.136 429.458ZM192.051 431.352L192.776 426.984H195.668L195.54 427.745H193.572L193.401 428.786H195.178L195.05 429.547H193.273L192.974 431.352H192.051ZM197.125 426.984L197.757 428.472H197.791L198.925 426.984H199.998L198.307 429.168L199.303 431.352H198.26L197.612 429.861H197.577L196.434 431.352H195.357L197.091 429.168L196.108 426.984H197.125Z",
    fill: "black"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.551114,
    y: 0.832364,
    width: 356.898,
    height: 487.898,
    rx: 10.4712,
    stroke: "#757575",
    strokeOpacity: 0.1,
    strokeWidth: 1.10223
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1660_11690",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1660_11690",
    transform: "matrix(0.00363856 0 0 0.00159422 -0.118514 -0.101894)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_11690",
    x1: 243.185,
    y1: 159.181,
    x2: 280.2,
    y2: 120.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#A47A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#A77D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#AA7F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#AD8227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#B08529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#B2872C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B58A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#B88D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481891,
    stopColor: "#BF9439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#C09539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#C1973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518109,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#C3983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#C3993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#C49A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#C69C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#C99F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#CEA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#D1A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D3A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#D4A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4AA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D5AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#D6AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#DCB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#E0BC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E1BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E1BE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#E5C56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#E7C76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E9C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E9CB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EBCD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#EDCF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EDD077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#EED279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F1D67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#F1D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#F2D87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#F4DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DE85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1660_11690",
    x1: 231.472,
    y1: 174.047,
    x2: 269.689,
    y2: 134.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494696,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505304,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#A57B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#AF8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#B2872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#B58A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#B88D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#BD9237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#C0953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#C2983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#C3983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#C59B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C89E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#CBA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#CEA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1660_11690",
    x1: 253.701,
    y1: 141.484,
    x2: 285.383,
    y2: 108.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#B78C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#B88D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#BA8F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#BA9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#BC9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#BD9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#BF9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C0953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#C1973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#C3993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#C49A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#C69C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#C89E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#C99F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#CBA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#D0A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#D4A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#D4AA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#D4AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#D5AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#D6AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#DCB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#DEB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#E0BC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#E1BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E4C268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E5C56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#E7C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#E7C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#EBCD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EDD077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#EED178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#EFD37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#F1D77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F3DA80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#F5DC84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F7DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#F8E189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FAE58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBE68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FCE88F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FEEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FDE790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976563,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F7DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1660_11690",
    x1: 261.875,
    y1: 124.735,
    x2: 289.488,
    y2: 95.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#D5AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#D6AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#D8B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#DBB559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#DCB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898437,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#DCB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#E0BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#E1BD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#E1BE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#E3C066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#E4C268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#E7C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#E9C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#E9CB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#EBCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EED178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EED279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#EFD37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#F0D57B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#F1D67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#F1D77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F6DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F7DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#F7E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F8E189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F9E38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FAE48B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FAE58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FEEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FDE891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566171,
    stopColor: "#FCE68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F4D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#F1D27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#EDCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#EAC56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#E9C36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C16B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1660_11690",
    x1: 266.162,
    y1: 108.653,
    x2: 291.072,
    y2: 82.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#F7DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FAE48B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FEE992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#FCE68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FBE58E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FBE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273437,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F8E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F8DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#F7DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#F5D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421696,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F3D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#F3D680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#F1D37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#F1D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F0CF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578304,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#E9C46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#E7C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E8C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#EAC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EFC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1CA72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1660_11690",
    x1: 267.284,
    y1: 92.9985,
    x2: 288.369,
    y2: 70.9487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#F6DA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#F5D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#F4D882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F3D680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#F1D37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1D27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0D17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#F0CF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#EAC46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414693,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E6BE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E6BE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585307,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EBC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#F1CA71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1660_11690",
    x1: 265.971,
    y1: 80.5823,
    x2: 286.536,
    y2: 59.0763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#EDCB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#EBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EAC56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#E9C46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#E9C36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#E7C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E6BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E6BE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9C26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EBC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439774,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560226,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FAD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#FAD277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1660_11690",
    x1: 264.265,
    y1: 69.4042,
    x2: 282.527,
    y2: 50.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EBC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F0C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F4CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4616,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FAD277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#F5CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#F0C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#E7C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7BF64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1660_11690",
    x1: 260.78,
    y1: 60.4419,
    x2: 278.724,
    y2: 41.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#ECC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F0C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#F4CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F8D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FAD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476692,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523308,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F9D176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F4CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F0C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E8C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E8C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E5BE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E4BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#E3BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#E2BB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#E1BA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#E0B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#E0B85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DDB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#DBB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8B156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1660_11690",
    x1: 256.514,
    y1: 52.4273,
    x2: 273.85,
    y2: 34.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489409,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510591,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#F7CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F3CC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E9C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#E5BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E4BD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E2BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#DFB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#DEB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#DEB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#DDB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#DCB559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#DBB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#D8B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#D7AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#D6AE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#D5AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#D4AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#D3AC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#D3AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D2AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D1AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A94E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1660_11690",
    x1: 253.963,
    y1: 44.8184,
    x2: 267.73,
    y2: 30.4236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F4CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F8D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493324,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506676,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FBD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F6CE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F3CB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F1C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#EFC86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#ECC569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#EAC368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#E7BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#E6BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E5BE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E4BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E2BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E1BA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#DFB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#DDB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#DDB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#DBB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D7AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6AF53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1660_11690",
    x1: 247.24,
    y1: 37.8276,
    x2: 259.814,
    y2: 24.6795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480359,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519641,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FDD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F5CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F3CC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F1C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EEC76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#EDC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#ECC569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#EAC368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E8C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E6BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E5BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E4BD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#E2BB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#E1BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#E0B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E0B85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DFB85C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#DDB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#DDB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1660_11690",
    x1: 114.573,
    y1: 159.189,
    x2: 77.5574,
    y2: 120.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#A47A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#A77D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#AA7F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#AD8227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#B08529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#B2872C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B58A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#B88D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481891,
    stopColor: "#BF9439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#C09539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#C1973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518109,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#C3983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#C3993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#C49A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#C69C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#C99F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#CEA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#D1A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D3A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#D4A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4AA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D5AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#D6AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#DCB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#E0BC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E1BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E1BE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#E5C56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#E7C76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E9C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E9CB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EBCD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#EDCF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EDD077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#EED279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F1D67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#F1D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#F2D87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#F4DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DE85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1660_11690",
    x1: 126.278,
    y1: 174.047,
    x2: 88.0606,
    y2: 134.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494696,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505304,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#A57B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#AF8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#B2872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#B58A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#B88D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#BD9237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#C0953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#C2983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#C3983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#C59B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C89E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#CBA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#CEA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1660_11690",
    x1: 104.088,
    y1: 141.484,
    x2: 72.4057,
    y2: 108.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#B78C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#B88D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#BA8F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#BA9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#BC9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#BD9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#BF9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C0953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#C1973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#C3993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#C49A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#C69C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#C89E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#C99F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#CBA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#D0A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#D4A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#D4AA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#D4AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#D5AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#D6AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#DCB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#DEB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#E0BC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#E1BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E4C268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E5C56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#E7C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#E7C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#EBCD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EDD077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#EED178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#EFD37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#F1D77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F3DA80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#F5DC84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F7DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#F8E189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FAE58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBE68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FCE88F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FEEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FDE790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976563,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F7DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1660_11690",
    x1: 95.8906,
    y1: 124.735,
    x2: 68.278,
    y2: 95.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#D5AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#D6AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#D8B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#DBB559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#DCB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898437,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#DCB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#E0BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#E1BD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#E1BE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#E3C066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#E4C268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#E7C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#E9C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#E9CB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#EBCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EED178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EED279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#EFD37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#F0D57B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#F1D67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#F1D77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F6DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F7DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#F7E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F8E189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F9E38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FAE48B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FAE58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FEEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FDE891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566171,
    stopColor: "#FCE68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F4D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#F1D27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#EDCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#EAC56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#E9C36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C16B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1660_11690",
    x1: 91.596,
    y1: 108.657,
    x2: 66.6859,
    y2: 82.6092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#F7DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FAE48B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FEE992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#FCE68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FBE58E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FBE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273437,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F8E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F8DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#F7DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#F5D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421696,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F3D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#F3D680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#F1D37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#F1D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F0CF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578304,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#E9C46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#E7C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E8C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#EAC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EFC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1CA72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1660_11690",
    x1: 90.4665,
    y1: 92.9985,
    x2: 69.3807,
    y2: 70.9487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#F6DA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#F5D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#F4D882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F3D680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#F1D37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1D27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0D17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#F0CF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#EAC46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414693,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E6BE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E6BE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585307,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EBC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#F1CA71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1660_11690",
    x1: 91.795,
    y1: 80.5823,
    x2: 71.2293,
    y2: 59.0763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#EDCB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#EBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EAC56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#E9C46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#E9C36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#E7C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E6BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E6BE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9C26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EBC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439774,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560226,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FAD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#FAD277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1660_11690",
    x1: 93.477,
    y1: 69.4003,
    x2: 75.2153,
    y2: 50.3051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EBC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F0C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F4CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4616,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FAD277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#F5CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#F0C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#E7C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7BF64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1660_11690",
    x1: 96.9931,
    y1: 60.4419,
    x2: 79.0492,
    y2: 41.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#ECC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F0C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#F4CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F8D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FAD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476692,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523308,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F9D176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F4CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F0C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E8C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E8C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E5BE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E4BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#E3BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#E2BB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#E1BA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#E0B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#E0B85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DDB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#DBB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8B156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1660_11690",
    x1: 101.243,
    y1: 52.4273,
    x2: 83.9074,
    y2: 34.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489409,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510591,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#F7CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F3CC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E9C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#E5BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E4BD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E2BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#DFB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#DEB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#DEB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#DDB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#DCB559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#DBB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#D8B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#D7AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#D6AE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#D5AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#D4AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#D3AC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#D3AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D2AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D1AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A94E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1660_11690",
    x1: 103.81,
    y1: 44.8184,
    x2: 90.0438,
    y2: 30.4236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F4CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F8D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493324,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506676,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FBD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F6CE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F3CB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F1C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#EFC86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#ECC569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#EAC368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#E7BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#E6BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E5BE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E4BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E2BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E1BA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#DFB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#DDB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#DDB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#DBB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D7AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6AF53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1660_11690",
    x1: 110.486,
    y1: 37.8276,
    x2: 97.913,
    y2: 24.6795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480359,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519641,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FDD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F5CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F3CC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F1C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EEC76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#EDC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#ECC569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#EAC368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E8C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E6BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E5BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E4BD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#E2BB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#E1BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#E0B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E0B85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DFB85C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#DDB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#DDB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1660_11690",
    x1: 190.046,
    y1: 176.737,
    x2: 170.772,
    y2: 125.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664063,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820313,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#B88D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#B98E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#BC9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#BF9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#C09539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#D4A94E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F8E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FDE891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCE790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F8E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#F8DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#F4D882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#EAC46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#E7C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E7BF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F7CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#EBC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#D5AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D3AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#D0A94E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#CEA74C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#CCA44A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#CAA247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#C7A045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#C59E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#C39B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#C1993E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#BF973C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#BC953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#BA9238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#B89036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#B68E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#B38C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#B1892F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#AF872D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#AD852A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#AA8228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#A88026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#A67E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#A47C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#A1791F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#9F771D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#9D751B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#9B7319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#987017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#A7802A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#B58F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B58F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B58F3E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_11690"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.28125,
    width: 358,
    height: 489,
    rx: 11.0223,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1660_11690",
    width: 340,
    height: 751,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulti1);
export default __webpack_public_path__ + "static/media/multi_1.7b5173dee05eb7800084bbd1460ea513.svg";
export { ForwardRef as ReactComponent };